<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2021-01-20 11:35:27
 * @LastEditors: daikeyi
 -->
<template>
    <div id='page_Container'>
        <div class="page">
            <div id='main-container' class="main-container">
                <van-pull-refresh :class="{returnListBox:!listShow}" v-model="isLoading" @refresh="onRefresh" class='refreshBox'>
                    <van-list v-model="ploading" :finished="finished" @load="onLoad">
                        <div class='returnList' v-for='item in dataList' :key='item.id'>
                            <van-card :title="item.productName" :thumb="item.productImg">
                                <template slot='desc'>
                                    <p class='descP'>{{item.specificationValue}}</p>
                                    <p class='numP'>
                                        <span>×{{item.quantity}}</span>
                                    </p>
                                </template>
                            </van-card>
                            <div class='returnType'>
                                <p>
                                    <img :src="refundUrl" alt="">
                                    <span class='spanType'>{{item.typeStr}}</span>
                                    <span>{{item.statusStr}}</span>
                                </p>
                            </div>
                            <div class='btnStyle'>
                                <van-button round @click='openGoodDetails(item)'>查看详情</van-button>
                            </div>
                        </div>
                    </van-list>
                    <div v-if='!listShow' class='noListStyle'>
                        <img :src="noListUrl" alt="">
                        <p>暂无订单！</p>
                    </div>
                </van-pull-refresh>
            </div>
        </div>
    </div>
</template>
<script>
import { toastLoading, clearToastLoading } from '@/utils/base/utils';

export default {
    data() {
        return {
            commodityUrl: require('../assets/img/myCenter/commodity.png'),
            refundUrl: require('../assets/img/myCenter/refund.png'),
            noListUrl: require('../assets/img/myCenter/noList.png'),
            pageNum: 1,
            pageSize: 4,
            ploading: false,
            finished: true,
            listShow: false,
            isLoading: false,
            dataList: []
        };
    },
    esvReady() {

    },
    esvShow() {
        document.title = '退款/售后';
        this.queryMemberRefundRecordList();
    },
    methods: {
        onRefresh() {
            setTimeout(() => {
                this.pageNum = 1;
                this.queryMemberRefundRecordList();
                this.isLoading = false;
            }, 500);
        },
        onLoad() {
            this.pageNum++;
            this.queryMemberRefundRecordList();
        },
        queryMemberRefundRecordList() {
            const ths = this;
            const params = {
                pageNum: ths.pageNum,
                pageSize: ths.pageSize
            };
            ths.finished = true;
            ths.listShow = true;
            ths.$doRequest(
                {
                    url: '/order/queryMemberRefundItemList',
                    params: params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        ths.finished = true;
                        ths.ploading = false;
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    const total = parseInt(data.result.total);
                    ths.dataList =
                        ths.pageNum === 1
                            ? data.result.list
                            : [...ths.dataList, ...data.result.list];

                    if (ths.dataList.length < total) {
                        ths.finished = false;
                    } else {
                        ths.finished = true;
                    }

                    if (ths.dataList.length > 0) {
                        ths.listShow = true;
                    } else {
                        ths.listShow = false;
                    }
                }
            );
        },
        openGoodDetails(item) {
            const ths = this;
            const params = {
                refundItemId: item.id
            };
            ths.$doRequest(
                {
                    url: '/order/queryMemberRefundItem',
                    params: params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    ths.ESVStorage.putSavedValue(
                        'refundSuccessData',
                        data.result
                    );
                    ths.esvOpenPage('OPReturnGoodsDetails');
                }
            );
        }
    }
};
</script>
<style lang="scss" scoped>
.returnListBox {
    display: flex;
    align-items: center; /*垂直居中*/
    justify-content: center; /*水平居中*/
}
.returnList {
    padding: 12px;
    background: #fff;
    margin-top: 12px;

    .returnType {
        border-bottom: 1px solid #f3f2f2;
        .spanType {
            padding: 0 10px;
        }
        img {
            width: 22px;
        }
        p {
            height: 40px;
            line-height: 40px;
            flex-direction: row;
            align-items: center;
            /*垂直居中*/
            display: flex;
        }
    }
    .btnStyle {
        text-align: right;
        padding-top: 12px;
        .van-button--default {
            border: 1px solid #ee2e50;
        }
        .van-button {
            height: 30px;
            line-height: 30px;
            font-size: 12px;
            padding: 0 12px;
            .van-button__text {
                color: #ee2e50 !important;
            }
        }
    }
}
.numP {
    span {
        float: right;
        color: #999;
    }
}
.noListStyle {
    text-align: center;
    img {
        width: 203px;
    }
    p {
        color: #999;
        padding-top: 20px;
        text-align: center;
    }
}
.refreshBox {
    height: 100%;
    overflow: auto;
}
</style>
